import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_business-match-hub-1/artifacts/ly54u1mk_7A4F7B0F-B2FC-4B29-8962-F57D33FF73A6.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="23rd Industries" 
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              Industrial & Fleet Dry Ice Blasting Solutions. Clean In-Place. Reduce Downtime. No Water. No Teardown.
            </p>
            <div className="space-y-3">
              <a href="tel:8172109693" className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-orange-500" />
                <span className="font-mono text-sm">(817) 210-9693</span>
              </a>
              <a href="tel:8773528760" className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors" data-testid="footer-tollfree">
                <Phone className="w-4 h-4 text-orange-500" />
                <span className="font-mono text-sm">(877) 352-8760</span>
              </a>
              <a href="mailto:operations@23rdindustries.com" className="flex items-center gap-3 text-zinc-400 hover:text-orange-500 transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4 text-orange-500" />
                <span className="font-mono text-sm">operations@23rdindustries.com</span>
              </a>
              <div className="flex items-start gap-3 text-zinc-400">
                <MapPin className="w-4 h-4 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Haltom City, TX<br/>DFW Metroplex + 100mi Radius</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white uppercase tracking-widest text-sm font-bold mb-6" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Services</h4>
            <ul className="space-y-3">
              {['Dry Ice Blasting', 'Fleet Cleaning', 'Fire Damage Cleanup', 'Mold Remediation', 'Equipment Restoration'].map((service) => (
                <li key={service}>
                  <Link to="/services" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h4 className="text-white uppercase tracking-widest text-sm font-bold mb-6" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Industries</h4>
            <ul className="space-y-3">
              {['Military Bases', 'Government Fleets', 'Manufacturing', 'Food Processing', 'Fleet Operations'].map((industry) => (
                <li key={industry}>
                  <Link to="/industries" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">
                    {industry}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white uppercase tracking-widest text-sm font-bold mb-6" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">About Us</Link></li>
              <li><Link to="/government" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">Government</Link></li>
              <li><Link to="/gallery" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">Gallery</Link></li>
              <li><Link to="/contact" className="text-zinc-400 hover:text-orange-500 text-sm transition-colors">Contact</Link></li>
            </ul>
            
            {/* Certifications */}
            <div className="mt-8">
              <h4 className="text-white uppercase tracking-widest text-sm font-bold mb-4" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>Certifications</h4>
              <div className="flex flex-wrap gap-2">
                <span className="badge bg-zinc-900 border border-zinc-800 px-3 py-1 text-zinc-400">Minority-Owned</span>
                <span className="badge bg-zinc-900 border border-zinc-800 px-3 py-1 text-zinc-400">Woman-Owned</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-zinc-500 text-sm font-mono">
              &copy; {currentYear} 23rd Environmental Units LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-zinc-500 text-xs font-mono">UEI: HWVZSJ4EWJ27</span>
              <span className="text-zinc-500 text-xs font-mono">CAGE: 1AQ57</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
